export default __webpack_public_path__ + "static/media/0188.2d15261c.jpg";